<template>
    <div id="selectBook">
        <headers :title='titles'
                 :type='is_active'></headers>
        <div class="content"
             v-if="firstLoad">
            <div class="content_left"
                 v-if='subject==21 || subject==91||subject==51'>
                <p v-if='is_active'
                   v-for="(item,index) in classlist"
                   @click="chooceClass(item,index)"
                   class='left_p'>
                    <span :class="{'left_p':!item.handler,'active':item.handler}">{{item.name}}</span>
                </p>
                <p v-if='!is_active'
                   v-for="(item,index) in classlist"
                   @click="chooceClass(item,index)"
                   :class="{'left_p':!item.handler,'active':item.handler}">{{item.name}}
                </p>
                <p v-if='!is_active&&code==13'
                   v-for="(item,index) in classlist2"
                   @click="chooceClass(item,index)"
                   :class="{'left_p':!item.handler,'active':item.handler}">{{item.name}}
                </p>
            </div>
            <div class="content_left"
                 v-else>
                <p v-for="(item,index) in classlist2"
                   @click="chooceClass(item,index)"
                   :class="{'left_p':!item.handler,'active':item.handler}">{{item.name}}
                </p>
            </div>
            <div class="content_right">
                <template>
                    <!-- <div v-if="!books && !books.length">
            <noResouse></noResouse>
          </div> -->
                    <div class="booklist"
                         v-if="books && books.length!==0">
                        <div :class="['item',{'border':is_active}]"
                             v-for="item in books"
                             @click="chooceBook(item.id,item.name,item.press_name)">
                            <span v-if='type==2'>{{item.name}}{{b_type[item.volume - 1]}}（{{item.press_name}}—{{item.version_name}}）</span>
                            <span v-else>
                                <template v-if="task_type>=0">
                                    <i> {{item.name}}</i>
                                </template>
                                <template v-else>
                                    <i v-if='subject==51 || subject ==21 || subject ==22'> {{item.name}}（{{item.press_name}}）</i>
                                    <i v-else> {{item.name}}（{{item.press_name}}—{{item.version_name}}）</i>
                                </template>
                            </span>
                            <span v-if='item.recommend'
                                  class='recommend'>教师推荐</span>
                            <br>
                        </div>

                        <!--<div class="item" v-for="item in books" @click="chooceBook(item.ct_ID)" v-if='subject==51'>-->
                        <!--<span>{{gradeList[(gradeId - 1)]}}{{b_type[(item.ct_SeesawVolumes - 1)]}}（{{item.name}}{{item.dict_Name}}）</span>-->
                        <!--<br>-->
                        <!--</div>-->
                    </div>
                    <div class="noresouse"
                         v-else>
                        <noResouse></noResouse>
                    </div>
                </template>
            </div>
        </div>
        <div v-else>
            <loading></loading>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'
import loading from 'COMPONENTS/base/tealoading.vue'

export default {
    data () {
        return {
            classlist: [{ name: "一年级", grade_id: '1', handler: false }, { name: "二年级", grade_id: '2', handler: false }, { name: "三年级", grade_id: '3', handler: false }, { name: "四年级", grade_id: '4', handler: false }, { name: "五年级", grade_id: '5', handler: false }, { name: "六年级", grade_id: '6', handler: false }],
            classlist2: [{ name: "七年级", grade_id: '7', handler: false }, { name: "八年级", grade_id: '8', handler: false }, { name: "九年级", grade_id: '9', handler: false }],
            gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级'],
            books: [],
            subject: parseInt(this.$route.params.subject), //学科
            type: parseInt(this.$route.params.type),
            b_type: ['上册', '下册', '全册'],
            gradeId: "",
            firstLoad: false,
            titles: '',
            sid: this.$route.params.sid,
            code: this.$route.params.code,
            task_type: this.$route.query.task_type,
            is_active: Number(this.$route.query.is_active),
            setCode: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013'],
            apiUrlType: '/public'
        }
    },
    components: {
        loading,
        headers,
        noResouse
    },
    created () {
        if (this.subject == 51) {
            if (this.task_type == 0 || this.task_type == 1) {
                this.apiUrlType = '/special'
            }
        }
        if (this.subject == 21) {
            if (this.task_type == 1 || this.task_type == 2 || this.task_type == 3) {
                this.apiUrlType = '/special'
            }
        }
        if (this.type == 1) {
            this.titles = '设置教材'
        } else if (this.type == 2) {
            this.titles = '设置教辅'
        }
        //数学和英语设置教材
        (async () => {

            // 获取教才   教材-1,教辅-2 默认为教材
            if (this.subject == 21 || this.subject == 91 || this.subject == 51) {
                this.gradeId = 1;
                this.classlist[0].handler = true;
            } else {
                this.gradeId = 7;
                this.classlist2[0].handler = true;
            }
            //活动修改
            let _url = this.code != 'null' ? API_URL_TASK_API + this.apiUrlType + `/book/get_list` : API_URL_HD_API + `/mid/stu/book/list`,
                _data = this.code != 'null' ? { "sid": this.subject, "book_type": this.type, "grade_id": this.gradeId, "task_type": this.task_type } : { "sid": this.subject, 'grade_id': this.gradeId, 'book_type': this.type };
            await this.$http.post(_url, _data).then(res => {
                this.books = res.data.data;
                this.firstLoad = true;
            });
        })();
    },
    methods: {
        chooceClass (item, index) {
            // this.firstLoad = false;
            let that = this;
            that.gradeId = item.grade_id;
            if (this.subject == 21 || this.subject == 91 || this.subject == 51) {
                that.classlist.forEach(book => {
                    book.handler = false;
                });
                if (this.code == 13) {
                    that.classlist2.forEach(book => {
                        book.handler = false;
                    });
                }
                item.handler = !item.handler;
                that.classlist.splice(index, 1, that.classlist[index]);
            } else {
                that.classlist2.forEach(book => {
                    book.handler = false;
                });
                if (this.code == 13) {
                    that.classlist2.forEach(book => {
                        book.handler = false;
                    });
                }
                item.handler = !item.handler;
                that.classlist2.splice(index, 1, that.classlist2[index]);
            }
            // 获取教才   教材-1,教辅-2 默认为教材
            let _url = null;
            //活动修改
            if (this.code != 'null') {
                _url = API_URL_TASK_API + this.apiUrlType + '/book/get_list?sid=' + that.subject + '&grade_id=' + item.grade_id + '&book_type=' + this.type + '&task_type=' + that.task_type;
            } else {
                _url = API_URL_HD_API + `/mid/stu/book/list?sid=${that.subject}&grade_id=${item.grade_id}`;
            }
            that.$http.post(_url).then(res => {
                if (res.data.response === 'ok') {
                    if (that.subject == 51) {
                        that.books = res.data.data;
                    } else {
                        that.books = res.data.data;
                    }
                }
                // this.firstLoad = true;
            })
        },
        chooceBook (id, name, press_name) {
            let _that = this;
            let code = this.setCode[this.code - 1]
            // code  值
            // 001  课件模块
            // 002  数学 视频作业
            // 003  数学 速算作业
            // 004  数学 同步习题  单元复习
            // 005  英语课前预习
            // 006  英语课后练习
            // 007  语文课前预习
            // 008  语文课后练习
            //book_type 0-教材,1-教辅 默认教材
            if (this.subject == 51) {

                if (this.code == 13) {
                    code = '013'
                } if (this.task_type == 0 || this.task_type == 1) {
                    code = '016'
                }

            }
            if (this.subject == 21) {
                if (this.task_type == 1) {
                    code = '016'
                }
                if (this.task_type == 2) {
                    code = '017'
                }
                if (this.task_type == 3) {
                    code = '019'
                }
            }
            let user_id = JSON.parse(localStorage.getItem('info')).user_id  //用户user_id
            layer.open({
                title: '提示',
                diff: 'tea',
                content: `确认使用此本教材?`,
                btn: ['确定', '取消'],
                yes: function (index) {
                    //活动修改
                    let _url = _that.code != 'null' ? API_URL_TASK_API + '/public/book/set_book' : API_URL_HD_API + '/mid/stu/book/change',
                        _data = _that.code != 'null' ? {
                            "book_id": id,
                            "sid": _that.subject,
                            "book_type": parseInt(_that.type - 1),
                            'user_id': user_id,
                            "code": code
                        } : {
                            "sid": _that.subject,
                            "book_id": id,
                            'book_version': press_name,
                            'grade_id': _that.gradeId,
                        };
                    _that.$http.post(_url, _data).then(res => {
                        layer.close(index);
                        if (res.data.response === 'ok') {
                            let o = {
                                sid: _that.subject,
                                book_type: _that.type,
                            }
                            layer.open({
                                content: '设置成功',
                                skin: 'msg',
                                time: 2
                            });
                            _that.$router.go(-1);
                        } else {
                            layer.open({
                                content: res.data.message,
                                btn: ['好的'],
                                skin: 'msg',
                                time: 5
                            });
                        }
                    })
                }
            })
        },
        getUserBook (o) {
            this.$http.post(DOMAIN_API_COURSEWARE_API_DJ_URLROOT + '/book/user', o).then(resp => {
                let res = resp.data;
                if (res.response === 'ok') {
                    this.$store.state.book = res.data;
                }
            })
        }
    },
    beforeRouteLeave (to, from, next) {
        layer.closeAll();
        next();
    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
// 期末活动
.recommend {
    position: absolute;
    top: 30px / $ppr;
    right: 45px / $ppr;
    background: #ff6655;
    color: #fff;
    width: 108px / $ppr;
    line-height: 38px / $ppr;
    font-size: 20px / $ppr;
    text-align: center;
    border-radius: 8px / $ppr;
}

body {
    padding-bottom: 0;
}
#selectBook {
    background: #f1f1f1;
    height: calc(100vh -2.4rem);
    height: -webkit-calc(100vh - 2.4rem);
}

.content {
    font-size: $md;
    color: $c;
    display: flex;
    display: -webkit-flex;
    // height: 100%;
    // min-height:92.5Vh;
    min-height: calc(100vh - 2.4rem);
    background: #f1f1f1;
    .content_left {
        flex: 2;
        -webkit-flex: 2;
        background-color: $c-fbg;
        // border-top: 2px solid $c-fbg;
        .left_p {
            height: $h-header;
            line-height: $h-header;
            text-align: center;
            width: 205px / $ppr;
        }
        .active {
            background-color: $c-hbg;
            color: $c-tag;
            height: $h-header;
            line-height: $h-header;
            text-align: center;
            width: 205px / $ppr;
        }
        span {
            color: #999999;
            padding: 15px / $ppr 40px / $ppr;
            border-radius: 30px / $ppr;
            background: #ebf4ff;
            &.active {
                background-color: #5dd6ff;
                color: #fff;
                height: $h-header;
                line-height: $h-header;
                text-align: center;
                width: 205px / $ppr;
            }
        }
    }
    .content_right {
        font-size: $lt;
        flex: 5;
        -webkit-flex: 5;
        text-align: left;
        background-color: $c-hbg;
        max-height: 1200px / $ppr;
        overflow: auto;
        position: relative;
        .firstLoad {
            top: 45%;
            left: 55%;
        }
    }
}
.booklist {
    .item {
        height: $h-header;
        line-height: $h-header;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 20px / $ppr;
        position: relative;
    }
    .border {
        width: 86%;
        margin: 0 auto;
        border-bottom: 1px / $ppr solid #cccccc;
    }
}
</style>
<style rel="stylesheet/scss" lang="scss">
.noresouse {
    .spinner {
        margin-top: -5.85rem !important;
    }
}
</style>
